import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { WhatsAppIcon } from './WhatsAppIcon';
export function FloatingWhatsApp() {
  const {
    language
  } = useLanguage();
  const whatsappUrl = language === 'en' ? 'https://wa.me/34613756211?text=Hello%2C%20I%20need%20a%20transfer%20in%20Ibiza.%0APickup%3A%0ADestination%3A%0ADate%3A%0ATime%3A%0APassengers%3A' : 'https://wa.me/34613756211?text=Hola%2C%20necesito%20un%20transfer%20en%20Ibiza.%0ARecogida%3A%0ADestino%3A%0AFecha%3A%0AHora%3A%0APasajeros%3A';
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 flex h-10 w-10 md:h-11 md:w-11 items-center justify-center rounded-full bg-whatsapp text-white shadow-sm transition-colors hover:bg-whatsapp-hover animate-whatsapp-pulse" aria-label="Contact us on WhatsApp" data-id="element-58">
      <WhatsAppIcon className="h-[18px] w-[18px] md:h-5 md:w-5" data-id="element-59" />
    </a>;
}